import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavComponent } from './sidenav/sidenav.component';
import { SidenavMenuComponent } from './sidenav-menu/sidenav-menu.component';
import { SidenavRecentActivityComponent } from './sidenav-recent-activity/sidenav-recent-activity.component';
import { SidenavTitleMenuComponent } from './sidenav-title-menu/sidenav-title-menu.component';
import { SidenavTemplatePreviewComponent } from './sidenav-template-preview/sidenav-template-preview.component';

@NgModule({
    imports: [
    CommonModule
    ],
    declarations: [
        SidenavComponent,
        SidenavMenuComponent,
        SidenavRecentActivityComponent,
        SidenavTitleMenuComponent,
        SidenavTemplatePreviewComponent,
    ],
    exports: [
        SidenavComponent,
        SidenavMenuComponent,
        SidenavRecentActivityComponent,
        SidenavTitleMenuComponent,
        SidenavTemplatePreviewComponent,
    ]
})
export class NgxUiSidenavModule { }
